import { useRouter } from 'next/router';
import { FC, useState } from 'react';
import OverviewNav from '../../../common/OverviewNav';
import { tabsValues } from '../../../config/pageConfig';
import Bundles from '../Bundles';
import StreamUltra from './StreamUltra';

interface IProps {
    isLogin?: boolean;
}

const formal: FC<IProps> = () => {
    const { query } = useRouter();
    const searchTab = query?.tab;
    let defaultTab = 'Overview';
    if (typeof searchTab === 'string' && tabsValues.includes(searchTab)) {
        defaultTab = searchTab;
    }
    const [activeTab, setActiveTab] = useState(defaultTab);
    // const [activePage, setActivePage] = useState(defaultPage);

    return (
        <>
            <OverviewNav activeTab={defaultTab} onTabChange={(val) => setActiveTab(val)} />
            {/* {activeTab === 'Overview' && activePage === 'stream' && <StreamSeries />} */}
            {activeTab === 'Overview' && <StreamUltra />}
            {/* {activeTab === 'Overview' && activePage === 'streamAcPro' && <StreamAcPro />} */}
        </>
    );
};
export default formal;
